export enum ClientPariListTab {
  ACTIVE = 'active',
  COMPLETED = 'finished',
  CANCELED = 'canceled',
}

export type PariSortBy = 'date' | 'amount' | 'status';
